import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Pagination,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  CircularProgress
} from '@mui/material';

// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import CustomModal from '../components/modal/CustomModal';


// hooks

import { useAxios } from '../context/AxiosHookContext';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// form
import { FormCreateUser } from "../components/forms/usersForms/createUsers"
import { useNotification } from '../context/NotificationContext';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Nombre', alignRight: false },
  { id: 'name', label: 'Departamento', alignRight: false },
  { id: 'email', label: "Correo", alignRight: false },
  { id: 'status', label: 'Roles', alignRight: false },
  { id: '' }
];

// ----------------------------------------------------------------------

export default function UsersPage() {

  const [open, setOpen] = useState(null);
  const [filterName, setFilterName] = useState('');

  const {showSnackbar} =  useNotification()

  const [openModaOrganizations, setOpenModalOrganizations] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [loading, setLoading] = useState(false)
  const [usersList, setusersList] = useState([])
  const [sync,setSync] = useState(false)
  const [valuesToEdit, setValuesToEdit] = useState({})

  const USERS_API = `/users?page=${page}&limit=10&displayName=${filterName}`
  const axios = useAxios();

  const handleOpenMenu = (event, values) => {
    setOpen(event.currentTarget);
    setValuesToEdit(values)
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };


  const getOrgs = useCallback(async () => {
    try {
      setusersList([])
      setLoading(true);
      const { data } = await axios.get(USERS_API);
      setusersList(data.data.list);
      setTotalPages(data.data.total_pages)

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [axios, USERS_API, setusersList, setLoading,filterName]);


  const syncUsers = useCallback(async () => {
    try {
      setSync(true)
      const {data} = await axios.get("/users/sync");
      
      setPage(1);
      setTotalPages(1);
      setFilterName("");
      showSnackbar({severity: "success",title:"Sincronizando",message: data?.data?.message || "Se han enviado a sincronización los usuarios de forma exitosa."})

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setSync(false);
    }
  }, [axios, USERS_API, getOrgs, setLoading,filterName]);


  useEffect(() => {
    getOrgs();
  }, [getOrgs, filterName])


  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };


  const handleFilterByName = (event) => {
    setPage(1);
    setFilterName(event.target.value);
  };

  return (
    <>
      <Helmet>
        <title>Usuarios | {process.env.REACT_APP_APP_NAME} </title>
      </Helmet>


        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Usuarios
          </Typography>
          <Button variant="contained" startIcon={sync ? <CircularProgress size={"15px"} sx={{ color: "white", marginRight: "6px" }} /> : <Iconify icon="eva:plus-fill" />} onClick={syncUsers}>
            {sync ? "Sincronizando usuarios" : "Sincronizar usuarios"}
          </Button>
        </Stack>

        <Card>
          <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} />

          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <UserListHead
                headLabel={TABLE_HEAD}
              />
              <TableBody>
                {usersList?.map((row) =>

                (
                  <TableRow hover key={row._id} tabIndex={-1} role="checkbox">

                    <TableCell component="th" scope="row" padding="normal">
                      <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography variant="subtitle2" noWrap>
                          {row.displayName}
                        </Typography>
                      </Stack>
                    </TableCell>

                    <TableCell align="left">
                      {row?.department ? `${row.department} (${row.departmentShortName})` : row?.departmentShortName || "N/A"}
                    </TableCell>

                    <TableCell align="left">
                      {row.mail}
                    </TableCell>

                    <TableCell align="left">
                      {(row?.role || ["Usuario"]).map((item) => (
                        <Label key={item} style={{margin: 3}} color={item === "Administrador" ? "success" : "error"}>{item}</Label>
                      ))}
                    </TableCell>



                    <TableCell align="right">
                      <IconButton size="large" color="inherit" onClick={(e) => handleOpenMenu(e, row)}>
                        <Iconify icon={'eva:more-vertical-fill'} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>

              {
                loading === true &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

              {
                (usersList.length === 0 && loading === false) &&
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >

                        <Typography variant="h6" paragraph>
                          Sin resultados
                        </Typography>

                        <Typography variant="body2">
                          No se encontraron resultados para
                          <br /> Intente con otra búsqueda.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              }

            </Table>
          </TableContainer>

          <Pagination
            count={totalPages}
            page={page}
            onChange={handleChangePage}

            sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
          />


        </Card>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={() => { setOpenModalOrganizations(true); setOpen(null) }} >
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Editar
        </MenuItem>
      </Popover>

      <CustomModal
        open={openModaOrganizations}
        modalStyle={{ maxWidth: 800, minWidth: 440 }}
        title={"Formulario de usuarios"}
      >
        <FormCreateUser
          onClose={() => setOpenModalOrganizations(false)}
          getValues={() => {
            getOrgs();
            setOpenModalOrganizations(false);
            setValuesToEdit({});
            setOpen(null);
          }}
          valuesToEdit={valuesToEdit}
        />
      </CustomModal>
    </>
  );
}
